<template>
    <v-snackbar v-model="show" :color="color" :timeout="timeout" :type="type" right>
        {{ message }}
        <template v-slot:action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="show = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    name: "DashboardCoreSnackBar",

    data() {
        return {
            show: false,
            message: "",
            color: "",
            timeout: null,
            type: "",
        };
    },

    created() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === "snackbar/showMessage") {
                this.message = state.snackbar.content;
                this.color = state.snackbar.color;
                this.timeout = state.snackbar.timeout;
                this.type = state.snackbar.type;
                this.show = true;
            } else if (mutation.type === "snackbar/hideMessage") {
                this.show = false;
            }
        });
    },
};
</script>
